# Route: /admin/system
# System info: version, uptime, counts, DB status

page-admin-system-info:
  type: Page
  archetype: dashboard
  meta:
    title: $t.admin.system.meta_title
    auth: required
  data:
    info:
      model: SystemInfo
      refresh: on_mount
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
    responsive:
      sm:
        padding: $spacing.sm
        padding_inline: $spacing.sm
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - system-info-header
    - system-info-cards

# ── Header ───────────────────────────────────────────────────────────────────

system-info-header:
  type: PageHeader
  title: $t.admin.system.title

# ── Info cards grid ──────────────────────────────────────────────────────────

system-info-cards:
  type: Section
  spatial:
    display: grid
    columns: repeat(2, 1fr)
    gap: $spacing.md
    responsive:
      sm:
        columns: 1fr
      md:
        columns: 1fr
  children:
    - system-card-version
    - system-card-uptime
    - system-card-tenants
    - system-card-db

system-card-version:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.xs
    padding: $spacing.lg
  tokens:
    background: $color_scheme.light.color.surface-elevated
    radius: $radius.lg
    shadow: $color_scheme.light.shadow.sm
  children:
    - system-version-label
    - system-version-value

system-version-label:
  type: Text
  content: $t.admin.system.label_version
  tokens:
    font_size: $font.size.sm
    color: $color_scheme.light.color.on-surface-muted

system-version-value:
  type: Text
  bind:
    content: info.version
  tokens:
    font_size: $font.size.xl
    color: $color_scheme.light.color.on-surface

system-card-uptime:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.xs
    padding: $spacing.lg
  tokens:
    background: $color_scheme.light.color.surface-elevated
    radius: $radius.lg
    shadow: $color_scheme.light.shadow.sm
  children:
    - system-uptime-label
    - system-uptime-value

system-uptime-label:
  type: Text
  content: $t.admin.system.label_uptime
  tokens:
    font_size: $font.size.sm
    color: $color_scheme.light.color.on-surface-muted

system-uptime-value:
  type: Text
  bind:
    content: info.uptimeSeconds
  tokens:
    font_size: $font.size.xl
    color: $color_scheme.light.color.on-surface

system-card-tenants:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.xs
    padding: $spacing.lg
  tokens:
    background: $color_scheme.light.color.surface-elevated
    radius: $radius.lg
    shadow: $color_scheme.light.shadow.sm
  children:
    - system-tenants-label
    - system-tenants-value

system-tenants-label:
  type: Text
  content: $t.admin.system.label_tenants
  tokens:
    font_size: $font.size.sm
    color: $color_scheme.light.color.on-surface-muted

system-tenants-value:
  type: Text
  bind:
    content: info.activeTenants
  tokens:
    font_size: $font.size.xl
    color: $color_scheme.light.color.on-surface

system-card-db:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.xs
    padding: $spacing.lg
  tokens:
    background: $color_scheme.light.color.surface-elevated
    radius: $radius.lg
    shadow: $color_scheme.light.shadow.sm
  children:
    - system-db-label
    - system-db-value

system-db-label:
  type: Text
  content: $t.admin.system.label_db
  tokens:
    font_size: $font.size.sm
    color: $color_scheme.light.color.on-surface-muted

system-db-value:
  type: Badge
  bind:
    content: info.dbStatus
